import request from "./config";

export default class VendorService {
  static create(data) {
    return request({
      url: "/vendor",
      method: "post",
      data,
    });
  }
  static update(id,data) {
    return request({
      url: `/vendor/${id}`,
      method: "patch",
      data,
    });
  }
  static delete(id) {
    return request({
      url: `/vendor/${id}`,
      method: "delete",
    });
  }
  static  find(params) {
    return request({
      url: `/vendor`,
      method: "get",
      params:params
    });
  }
  static  searchDocument(params) {
    return request({
      url: `/vendor/search`,
      method: "get",
      params:params
    });
  }
}
